import TasksLayout from "@/src/components/TasksPage/TasksLayout";

const TasksPage = () => {
  return <TasksLayout />;
};

export default TasksPage;
